//TODO: rename accepted to claimed
export enum AssessmentInviteStatus {
  Invited = "invited",
  Accepted = "accepted",
  InProgress = "in_progress",
  Done = "done",
  Started = "started",
  Rescinded = "rescinded",
}

export enum InvitesFit {
  best = "Best",
  middle = "Middle",
  worst = "Worst",
}

export enum AssessmentTestStatus {
  done = "Completed",
  in_progress = "In Progress",
  not_started = "Not Started",
}
